/*
Cabinet Hinges
  --closeType <string::enum> | ['Soft', 'Free Swing', 'Self']
  --degreeOfOpen <float> | degrees
  --attachmentMethod <string::enum> | ['Insert', 'Screw', 'Press In']
  --overlay <string::enum> ['Inset', 'Full', 'Half']
  --loadWeight <float> | pounds
*/
import { decimal } from 'vuelidate/lib/validators'
import hardwareFormFields from '@/modules/standardItems/schemas/hardware/form'
import { loadWeight } from '@/modules/standardItems/schemas/baseFormFields'

export default [
  ...hardwareFormFields,
  {
    key: 'degreeOfOpen',
    value: 'degreeOfOpen',
    type: 'float',
    classes: ['xs12', 'sm4'],
    attributes: {
      label: 'Degree of Open',
      suffix: 'deg',
      class: ['input--dense']
    },
    validation: [
      {
        validationKey: 'decimal',
        validationFunction: decimal,
        errorMessage: 'This should be a number'
      }
    ]
  },
  loadWeight(),
  {
    key: 'closeType',
    value: 'closeType',
    type: 'select',
    default: 'Soft',
    classes: ['xs12', 'sm4'],
    attributes: {
      label: 'Close Type',
      class: ['input--dense']
    },
    values: ['Soft', 'Free Swing', 'Self']
  },
  {
    key: 'attachmentMethod',
    value: 'attachmentMethod',
    type: 'select',
    default: 'Insert',
    attributes: {
      label: 'Attachment',
      class: ['xs12', 'sm4']
    },
    values: ['Insert', 'Screw', 'Press In']
  },
  {
    key: 'overlay',
    value: 'overlay',
    type: 'select',
    default: 'Inset',
    classes: ['xs12', 'sm4'],
    attributes: {
      label: 'Overlay',
      class: ['input--dense']
    },
    values: ['Inset', 'Full', 'Half']
  }
]
